<h2 mat-dialog-title>
  <mat-icon class="titel-icon">{{ typIcon }}</mat-icon>
  Liste aktualisieren
</h2>

<mat-dialog-content>

  <p class="liste">
    <strong>{{ data.liste.name }}</strong>
    <span class="liste-meta">{{ typTitel }} · bisher „{{ data.liste.dateiName }}“ · {{ data.liste.eintraegeAnzahl }} Einträge</span>
  </p>

  <p class="erklaerung">
    Lade eine neuere Excel-Version derselben Liste hoch. Vorhandene Einträge werden aktualisiert
    (ihr Prüfstatus bleibt), neue hinzugefügt und Einträge, die in der neuen Datei fehlen, gelöscht.
    Es wird keine zweite Liste angelegt. Vor dem Update siehst du, was sich ändert.
  </p>

  <!-- DATEI -->
  <div class="datei-zeile">
    <input #dateiInput type="file" accept=".xlsx,.xlsm,.xls" hidden (change)="dateiGewaehlt($event)">

    <button mat-stroked-button color="primary" type="button" (click)="dateiInput.click()" [disabled]="laedt || wendetAn">
      <mat-icon>upload_file</mat-icon>
      {{ datei ? 'Andere Datei wählen' : 'Neue Excel-Datei wählen' }}
    </button>

    <span class="datei-name" *ngIf="datei">{{ datei.name }}</span>

    <label class="blatt-auswahl" *ngIf="vorschau && vorschau.blaetter.length > 1">
      Tabellenblatt
      <select [value]="sheetName" [disabled]="laedt || wendetAn" (change)="blattWechseln($event)">
        <option *ngFor="let b of vorschau.blaetter" [value]="b">{{ b }}</option>
      </select>
    </label>
  </div>

  <mat-progress-bar mode="indeterminate" *ngIf="laedt"></mat-progress-bar>

  <div class="fehler" *ngIf="fehler">
    <mat-icon inline>error_outline</mat-icon>
    <span>{{ fehler }}</span>
  </div>

  <!-- VORSCHAU -->
  <ng-container *ngIf="vorschau as v">

    <div class="warnung" *ngFor="let w of v.warnungen">
      <mat-icon inline>warning_amber</mat-icon> {{ w }}
    </div>

    <div class="gleich" *ngIf="v.typPasst && v.ohneUnterschied">
      <mat-icon inline>check_circle</mat-icon>
      Die neue Datei ist inhaltlich identisch mit dem Bestand ({{ v.unveraendert }} Einträge).
    </div>

    <div class="zahlen" *ngIf="v.typPasst">
      <div class="zahl" [class.zahl-null]="v.unveraendert === 0">
        <strong>{{ v.unveraendert }}</strong><span>unverändert</span>
      </div>
      <div class="zahl zahl-update" [class.zahl-null]="v.aktualisiert === 0">
        <strong>{{ v.aktualisiert }}</strong><span>aktualisiert</span>
      </div>
      <div class="zahl zahl-neu" [class.zahl-null]="v.neu === 0">
        <strong>{{ v.neu }}</strong><span>neu</span>
      </div>
      <div class="zahl zahl-geloescht" [class.zahl-null]="v.geloescht === 0">
        <strong>{{ v.geloescht }}</strong><span>zu löschen</span>
      </div>
      <div class="zahl zahl-geprueft" [class.zahl-null]="v.gepruefteBetroffen === 0"
        matTooltip="Geprüfte Signale, deren Zeile aktualisiert oder gelöscht wird – der Prüfstatus bleibt in jedem Fall erhalten">
        <strong>{{ v.gepruefteBetroffen }}</strong><span>geprüfte betroffen</span>
      </div>
      <div class="zahl zahl-konflikt" [class.zahl-null]="v.konflikte === 0">
        <strong>{{ v.konflikte }}</strong><span>Konflikte</span>
      </div>
      <div class="zahl zahl-zuvor" [class.zahl-null]="v.zuvorManuellGeloescht === 0" *ngIf="v.zuvorManuellGeloescht > 0">
        <strong>{{ v.zuvorManuellGeloescht }}</strong><span>zuvor manuell gelöscht</span>
      </div>
    </div>

    <ul class="hinweise" *ngIf="v.typPasst && !v.ohneUnterschied">
      <li *ngIf="v.geprueftAktualisiert > 0">
        {{ v.geprueftAktualisiert }} geprüfte Signal{{ v.geprueftAktualisiert === 1 ? '' : 'e' }} werden aktualisiert –
        der Prüfstatus bleibt<ng-container *ngIf="v.geprueftSeitPruefungGeaendert > 0">;
        {{ v.geprueftSeitPruefungGeaendert }} davon mit prüfrelevanter Änderung erhalten die Kennzeichnung „Seit Prüfung geändert“</ng-container>.
      </li>
      <li *ngIf="v.geprueftGeloeschtMitWeiterenQuellen > 0">
        {{ v.geprueftGeloeschtMitWeiterenQuellen }} geprüfte Signal{{ v.geprueftGeloeschtMitWeiterenQuellen === 1 ? '' : 'e' }}
        verlieren eine Quelle, bleiben aber über ihre andere Liste samt Prüfung in der Prüfung.
      </li>
      <li *ngIf="v.geprueftGeloeschtArchiviert > 0">
        {{ v.geprueftGeloeschtArchiviert }} geprüfte Signal{{ v.geprueftGeloeschtArchiviert === 1 ? '' : 'e' }} verschwinden aus der
        Prüfung (einzige Quelle gelöscht); der Prüfverlauf bleibt archiviert.
      </li>
      <li *ngIf="v.signaleUngeprueftGeloescht > 0">
        {{ v.signaleUngeprueftGeloescht }} ungeprüfte Signal{{ v.signaleUngeprueftGeloescht === 1 ? '' : 'e' }} werden mit ihrer Zeile entfernt.
      </li>
      <li *ngIf="v.anlagenteilSpalte">
        Anlagenteile aus „{{ v.anlagenteilSpalte }}“: {{ v.anlagenteileNeu }} neu, {{ v.anlagenteilZuordnungenGeaendert }} Zuordnung{{ v.anlagenteilZuordnungenGeaendert === 1 ? '' : 'en' }} geändert.
        Vorhandene Anlagenteile werden nie gelöscht.
      </li>
    </ul>

    <!-- ZUVOR MANUELL GELÖSCHT -->
    <div class="zuvor" *ngIf="v.zuvorManuellGeloescht > 0">
      <mat-checkbox [(ngModel)]="geloeschteWiederherstellen" [disabled]="wendetAn">
        {{ v.zuvorManuellGeloescht }} zuvor manuell gelöschte Zeile{{ v.zuvorManuellGeloescht === 1 ? '' : 'n' }} wiederherstellen
      </mat-checkbox>
      <p>Ohne diese Option bleiben manuell gelöschte Zeilen gelöscht, auch wenn die neue Datei sie enthält.</p>
    </div>

    <!-- DETAILS -->
    <mat-accordion class="details" *ngIf="v.typPasst && !v.ohneUnterschied" multi>

      <mat-expansion-panel *ngIf="v.konfliktListe.length > 0" expanded>
        <mat-expansion-panel-header>
          <mat-panel-title><mat-icon inline>report_problem</mat-icon> Konflikte – werden nicht verändert</mat-panel-title>
          <mat-panel-description>{{ v.konflikte }}</mat-panel-description>
        </mat-expansion-panel-header>
        <div class="konflikt" *ngFor="let k of v.konfliktListe; trackBy: trackByKonflikt">
          <p class="konflikt-grund">{{ k.grund }}</p>
          <div class="konflikt-seiten">
            <div>
              <span class="konflikt-titel">Bestand</span>
              <div class="eintrag" *ngFor="let e of k.bestand">
                <span class="eintrag-haupt">{{ e.signalname || '–' }} <span class="mono">{{ e.adresseOriginal }}</span></span>
                <span class="eintrag-meta">Zeile {{ e.alteZeile }}<ng-container *ngIf="e.geprueft"> · geprüft ({{ statusText(e) }})</ng-container></span>
              </div>
            </div>
            <div>
              <span class="konflikt-titel">Neue Datei</span>
              <div class="eintrag" *ngFor="let e of k.neueZeilen">
                <span class="eintrag-haupt">{{ e.signalname || '–' }} <span class="mono">{{ e.adresseOriginal }}</span></span>
                <span class="eintrag-meta">Zeile {{ e.neueZeile }}</span>
              </div>
            </div>
          </div>
        </div>
      </mat-expansion-panel>

      <mat-expansion-panel *ngIf="v.aktualisierte.length > 0">
        <mat-expansion-panel-header>
          <mat-panel-title><mat-icon inline>edit</mat-icon> Aktualisierte Einträge</mat-panel-title>
          <mat-panel-description>{{ v.aktualisiert }}</mat-panel-description>
        </mat-expansion-panel-header>
        <div class="eintrag" *ngFor="let e of v.aktualisierte; trackBy: trackByEintrag" [class.eintrag-geprueft]="e.geprueft">
          <span class="eintrag-haupt">
            {{ e.signalname || '–' }} <span class="mono">{{ e.adresseOriginal }}</span>
            <span class="chip chip-geprueft" *ngIf="e.geprueft" matTooltip="Prüfstatus bleibt erhalten">{{ statusText(e) }}</span>
            <span class="chip chip-geaendert" *ngIf="e.pruefrelevant">Seit Prüfung geändert</span>
            <span class="chip" *ngIf="e.ausPruefungEntfernt" matTooltip="Bleibt aus der Prüfung entfernt">aus Prüfung entfernt</span>
          </span>
          <span class="eintrag-meta">{{ zeileText(e) }} · {{ aenderungText(e) || e.hinweis }}</span>
          <span class="eintrag-meta" *ngIf="e.hinweis && aenderungText(e)">{{ e.hinweis }}</span>
        </div>
        <p class="gekuerzt" *ngIf="gekuerzt(v.aktualisierte, v.aktualisiert)">… und {{ v.aktualisiert - v.aktualisierte.length }} weitere.</p>
      </mat-expansion-panel>

      <mat-expansion-panel *ngIf="v.neue.length > 0">
        <mat-expansion-panel-header>
          <mat-panel-title><mat-icon inline>add_circle_outline</mat-icon> Neue Einträge</mat-panel-title>
          <mat-panel-description>{{ v.neu }}</mat-panel-description>
        </mat-expansion-panel-header>
        <div class="eintrag" *ngFor="let e of v.neue; trackBy: trackByEintrag">
          <span class="eintrag-haupt">{{ e.signalname || '–' }} <span class="mono">{{ e.adresseOriginal }}</span></span>
          <span class="eintrag-meta">{{ zeileText(e) }}<ng-container *ngIf="e.stationsName"> · {{ e.stationsName }}</ng-container><ng-container *ngIf="e.anlagenteilNeu"> · Anlagenteil „{{ e.anlagenteilNeu }}“</ng-container></span>
        </div>
        <p class="gekuerzt" *ngIf="gekuerzt(v.neue, v.neu)">… und {{ v.neu - v.neue.length }} weitere.</p>
      </mat-expansion-panel>

      <mat-expansion-panel *ngIf="v.geloeschte.length > 0">
        <mat-expansion-panel-header>
          <mat-panel-title><mat-icon inline>remove_circle_outline</mat-icon> Nicht mehr in der Datei – werden gelöscht</mat-panel-title>
          <mat-panel-description>{{ v.geloescht }}</mat-panel-description>
        </mat-expansion-panel-header>
        <div class="eintrag eintrag-geloescht" *ngFor="let e of v.geloeschte; trackBy: trackByEintrag" [class.eintrag-geprueft]="e.geprueft">
          <span class="eintrag-haupt">
            {{ e.signalname || '–' }} <span class="mono">{{ e.adresseOriginal }}</span>
            <span class="chip chip-geprueft" *ngIf="e.geprueft">{{ statusText(e) }}</span>
          </span>
          <span class="eintrag-meta">Zeile {{ e.alteZeile }} · {{ e.hinweis }}</span>
        </div>
        <p class="gekuerzt" *ngIf="gekuerzt(v.geloeschte, v.geloescht)">… und {{ v.geloescht - v.geloeschte.length }} weitere.</p>
      </mat-expansion-panel>

      <mat-expansion-panel *ngIf="v.zuvorGeloeschte.length > 0">
        <mat-expansion-panel-header>
          <mat-panel-title><mat-icon inline>history</mat-icon> Zuvor manuell gelöscht</mat-panel-title>
          <mat-panel-description>{{ v.zuvorManuellGeloescht }}</mat-panel-description>
        </mat-expansion-panel-header>
        <div class="eintrag" *ngFor="let e of v.zuvorGeloeschte; trackBy: trackByEintrag">
          <span class="eintrag-haupt">{{ e.signalname || '–' }} <span class="mono">{{ e.adresseOriginal }}</span></span>
          <span class="eintrag-meta">{{ zeileText(e) }} · {{ e.hinweis }}</span>
        </div>
      </mat-expansion-panel>

    </mat-accordion>

  </ng-container>

</mat-dialog-content>

<mat-dialog-actions align="end">
  <span class="blockiert" *ngIf="blockiertGrund && datei && !laedt">{{ blockiertGrund }}</span>
  <button mat-button type="button" (click)="abbrechen()" [disabled]="wendetAn">Abbrechen</button>
  <button mat-raised-button color="primary" type="button" (click)="anwenden()" [disabled]="!kannAnwenden"
    [matTooltip]="blockiertGrund || ''">
    <mat-spinner diameter="16" *ngIf="wendetAn"></mat-spinner>
    <mat-icon *ngIf="!wendetAn">sync</mat-icon>
    Liste aktualisieren
  </button>
</mat-dialog-actions>
